import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLID = () => {
  return (
    <div className="html-container">
      <h1>HTML – ID</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          In HTML, the <code>id</code> attribute assigns a unique identifier to an element. 
          IDs are primarily used for styling, JavaScript targeting, and navigation.
        </p>
      </section>

      {/* 2. Syntax */}
      <section id="syntax">
        <h2>2. Syntax</h2>
        <pre>
          <code>{`<element id="uniqueID">Content</element>`}</code>
        </pre>
        <p>Each ID must be unique within the HTML document.</p>
      </section>

      {/* 3. Applying CSS with IDs */}
      <section id="css-id">
        <h2>3. Applying CSS with IDs</h2>
        <p>Example of using an ID for styling:</p>
        <pre>
          <code>{`<style>
#header {
  background-color: #007bff;
  color: white;
  padding: 20px;
  text-align: center;
}
</style>

<div id="header">This is a header with an ID.</div>`}</code>
        </pre>
      </section>

      {/* 4. Targeting IDs with JavaScript */}
      <section id="javascript-id">
        <h2>4. Targeting IDs with JavaScript</h2>
        <p>You can select elements by ID using JavaScript:</p>
        <pre>
          <code>{`<script>
const header = document.getElementById('header');
header.style.fontSize = '2rem';
</script>`}</code>
        </pre>
      </section>

      {/* 5. Navigation using IDs */}
      <section id="navigation-id">
        <h2>5. Navigation using IDs</h2>
        <p>IDs can be used as anchors for navigation:</p>
        <pre>
          <code>{`<a href="#section1">Go to Section 1</a>
<section id="section1">
  <h2>Section 1</h2>
  <p>Content of section 1...</p>
</section>`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Ensure IDs are unique within the page.</li>
          <li>Use descriptive names that indicate the element’s purpose.</li>
          <li>Prefer classes for styling multiple elements; use IDs for unique elements.</li>
          <li>Follow lowercase and hyphen-separated naming conventions for readability.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>The <code>id</code> attribute assigns a unique identifier to HTML elements.</li>
          <li>IDs are used for CSS styling, JavaScript targeting, and navigation anchors.</li>
          <li>Each ID must be unique in the HTML document.</li>
          <li>Use descriptive, consistent names for maintainable code.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLID;
